import { Directive, Inject, Input, OnInit, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { MapComponent } from './map.component';
import { GREEN_20 } from '@app/lib/colors';

interface ILocationCoords {
  lat: number;
  lng: number;
  [key: string]: any;
}

export interface ICustomPolylineOptions {
  autoZoom: boolean;
}

@Directive({
  selector: 'map-polyline',
})
export class MapPolylineDirective implements OnInit, OnChanges, OnDestroy {
  @Input() public coords: ILocationCoords[];
  @Input() public markers?: google.maps.IconSequence[];
  @Input() public autoZoom;
  @Input() public color: string = GREEN_20;
  @Input() public zIndex = 0;
  @Input() public width = 0;
  private id: string;
  private gmaps;
  private polyline: google.maps.Polyline;
  private polylineOptions: google.maps.PolylineOptions;

  constructor(@Inject(MapComponent) private map: MapComponent) {}

  public ngOnInit(): void {
    this.map.createMapPromise.then(() => {
      this.gmaps = this.map.gmaps;
      this.setPolylineOptions();
      this.createPolyline(this.polylineOptions, this.autoZoom);
    });
  }

  public ngOnChanges(changes: SimpleChanges): void {
    const coords = changes.coords;
    if (this.gmaps && this.id && !coords.firstChange && coords.currentValue.length !== changes.coords.previousValue.length) {
      this.polyline.setPath(this.toLatLngs(this.coords));
    }
  }

  public ngOnDestroy(): void {
    this.remove();
  }

  private remove(): void {
    if (this.id) this.map.removePolyline(this.id);
  }

  private toLatLngs(coords: ILocationCoords[]): google.maps.LatLng[] {
    return coords.map((coord: ILocationCoords): google.maps.LatLng => new this.gmaps.LatLng(coord.lat, coord.lng));
  }

  private setPolylineOptions(): void {
    this.polylineOptions = {
      path: this.toLatLngs(this.coords),
      icons: this.markers,
      strokeColor: this.color,
      strokeOpacity: 1.0,
      strokeWeight: +this.width,
      zIndex: +this.zIndex,
    };
  }

  private createPolyline(opts: google.maps.PolylineOptions, autoZoom: any = true): void {
    const options: ICustomPolylineOptions = {
      autoZoom: !!autoZoom,
    };
    this.polyline = new this.gmaps.Polyline(opts);
    this.id = this.map.addPolyline(this.polyline, options);
  }
}
